<div class="row">
    <div class="col-md-4">
        <label class="f-label">IRN No.</label>
        <mat-form-field appearance="outline" class="w-100">
            <input disabled matInput [matTooltip]="irnData.U_UTL_IRN" matTooltipPosition="below"
            [ngModel]="irnData.U_UTL_IRN" />
        </mat-form-field>   
    </div>
    <div class="col-md-4">
        <label class="f-label">IRN Status</label>
        <mat-form-field appearance="outline" class="w-100">
            <input disabled matInput [matTooltip]="irnData.U_UTL_IST" matTooltipPosition="below"
            [ngModel]="irnData.U_UTL_IST" />
        </mat-form-field>
    </div>
    <div class="col-md-4">
        <label class="f-label">IRN QR</label> 
        <mat-form-field appearance="outline" class="w-100">
            <input disabled matInput [matTooltip]="irnData.U_UTL_QRPT" matTooltipPosition="below"
            [ngModel]="irnData.U_UTL_QRPT" />
        </mat-form-field>
    </div>
    <div class="col-md-4">
        <label class="f-label">IRN Cancel Date</label>
        <mat-form-field appearance="outline" class="w-100">
            <input disabled matInput [matTooltip]="irnData.U_UTL_CANDT" matTooltipPosition="below"
            [ngModel]="irnData.U_UTL_CANDT" />
        </mat-form-field>
    </div>
    <div class="col-md-4">
        <label class="f-label">IRN Generate Date</label>
        <mat-form-field appearance="outline" class="w-100">
            <input disabled matInput [matTooltip]="irnData.U_UTL_IRNGENDT" matTooltipPosition="below"
            [ngModel]="irnData.U_UTL_IRNGENDT" />
        </mat-form-field>
    </div>
    <div class="col-md-4">
        <label class="f-label">IRN Remark</label>
         <mat-form-field appearance="outline" class="w-100">
            <input disabled matInput [matTooltip]="irnData.U_UTL_RMK" matTooltipPosition="below" 
            [ngModel]="irnData.U_UTL_RMK" />
            <!-- <img src="./assets/images/expand.svg" class="pointer" width="20" alt="theme" (click)="openRemarksDialog(irnData.U_UTL_RMK)"> -->
        </mat-form-field>
    </div>
</div>